import { Outlet } from 'react-router-dom';

import UnauthorizedPage from '../auth/pages/UnauthorizedPage';
import { usePermissions } from '../hooks/auth/usePermissions';

interface PermissionProtectedRouteProps {
  /** Permiso requerido para entrar. */
  perm?: string;
  /** O: al menos uno de estos. */
  anyOf?: string[];
}

/**
 * Guarda de ruta por permiso. Los permisos vienen del JWT (Redux), asi que la
 * comprobacion es sincrona — no hace falta un estado de carga como en
 * `RoleProtectedRoute`. Usar envolviendo un `<Route element={...}>`:
 *
 *   <Route element={<PermissionProtectedRoute perm="USERS_VIEW" />}>
 *     <Route path="/users" element={<Users />} />
 *   </Route>
 */
const PermissionProtectedRoute = ({
  perm,
  anyOf,
}: PermissionProtectedRouteProps) => {
  const { can, canAny } = usePermissions();

  const allowed = perm ? can(perm) : anyOf ? canAny(anyOf) : true;

  return allowed ? <Outlet /> : <UnauthorizedPage />;
};

export default PermissionProtectedRoute;
